"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Supercapacitors = void 0;
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Tags_1 = require("../Tags");
const Resources_1 = require("../../Resources");
const Size_1 = require("../render/Size");
const Units_1 = require("../../Units");
const SelectAmount_1 = require("../../inputs/SelectAmount");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
class Supercapacitors extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.SUPERCAPACITORS,
            cost: 4,
            tags: [Tags_1.Tags.ENERGY, Tags_1.Tags.BUILDING],
            productionBox: Units_1.Units.of({ megacredits: 1 }),
            metadata: {
                cardNumber: 'X46',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.text('EFFECT: CONVERTING ENERGY TO HEAT DURING PRODUCTION IS OPTIONAL FOR EACH ENERGY RESOURCE.', Size_1.Size.SMALL);
                    b.br.br;
                    b.production((pb) => pb.megacredits(1));
                }),
                description: 'Increase your M€ production 1 step.',
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 1);
        return undefined;
    }
    static onProduction(player) {
        if (player.energy === 0) {
            player.finishProductionPhase();
            return;
        }
        const selectAmount = new SelectAmount_1.SelectAmount('Select amount of energy to convert to heat', 'Convert energy', (amount) => {
            player.energy -= amount;
            player.heat += amount;
            player.game.log('${0} converted ${1} units of energy to heat', (b) => b.player(player).number(amount));
            player.finishProductionPhase();
            return undefined;
        }, 0, player.energy);
        if (player.hasConceded) {
            selectAmount.cb(player.energy);
            return;
        }
        player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
            return selectAmount;
        }));
    }
}
exports.Supercapacitors = Supercapacitors;
//# sourceMappingURL=Supercapacitors.js.map